import React, { useContext, useState } from 'react'
import UserContext from '../../context/Globales/UserContext';
import { makeStyles, Tooltip, CssBaseline, Grid, Typography, Paper, Card, CardContent, Divider, Button, Icon, Box } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import CardsHeader from './CardsHeader';
import Cards from './Cards';
import DataTableInfoComercial from './DataTableInfoComercial';
import DataTableRelacionCtaRut from './DataTableRelacionCtaRut';
import { GetBanco } from '../../context/types';

import Error from '../Error'

import { useHistory } from 'react-router-dom';

import FindInPageIcon from '@material-ui/icons/FindInPage';
import DateRangeIcon from '@material-ui/icons/DateRange';
import DescriptionIcon from '@material-ui/icons/Description';
import AssignmentIcon from '@material-ui/icons/Assignment';


import InformeOnp from '../pdf/IC/InformeOnp';

import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import { globales, mensajeglobales } from '../../helpers/Confi';
import CardsHeaderMobile from './CardsHeaderMobile';
import { isMobile } from 'react-device-detect';
const useStyle = makeStyles((theme) => ({
    buttonSuccess: {
        backgroundColor: '#04ba65',
        color: 'white',
        '&:hover': {
            backgroundColor: '#02bf67',
            color: 'white',
        },
    },
    buttonNo: {
        backgroundColor: theme.palette.secondary.main,
        color: 'white',
    },
    button: {
        backgroundColor: 'white',
        color: 'dark',
    },
    table: {
        backgroundColor: theme.palette.greyFondo.main,
    },
    sizeIcono: {
        maxHeight: '38px',
        minWidth: '38px',
        color: theme.palette.fondoiconos.main,
    },
    print: {
        '& > svg': {
            margin: theme.spacing(2),
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    papermodal: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 'auto',
        height: 'auto'
    },



}));




const InfoVerificacionTest = () => {

    //const userContext = useContext(UserContext);

    const { DataOnp } = useContext(UserContext);
    const [busqueda, setBusqueda] = useState(JSON.parse(localStorage.getItem('busqueda')));

    const [open, setOpen] = useState(false);

    const history = useHistory();
    const classes = useStyle();


    const parametros = globales();  //  parametros globales:


    const Verificacion = DataOnp.Verificacion;


    const banco = busqueda.banco;
    const ctacte = busqueda.ctacte
    const monto = busqueda.monto
    const nrodoc = busqueda.nrodoc
    const serieRUT = busqueda.serieRUT



    function number_format(amount, decimals) {

        amount += ''; // por si pasan un numero en vez de un string
        amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto

        decimals = decimals || 0; // por si la variable no fue fue pasada

        // si no es un numero o es igual a cero retorno el mismo cero
        if (isNaN(amount) || amount === 0)
            return parseFloat(0).toFixed(decimals);

        // si es mayor o menor que cero retorno el valor formateado como numero
        amount = '' + amount.toFixed(decimals);

        var amount_parts = amount.split('.'),
            regexp = /(\d+)(\d{3})/;

        while (regexp.test(amount_parts[0]))
            amount_parts[0] = amount_parts[0].replace(regexp, '$1' + '.' + '$2');

        return amount_parts.join('.');
    }

    //fn para modal pdf
    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false);
    }





    let Codigo = banco
    let nombre = '';

    switch (Codigo) {
        case '1':
            nombre = 'BANCO DE CHILE'
            break;

        case '9':
            nombre = 'BANCO INTERNACIONAL'
            break;
        case '12':
            nombre = 'BANCO DEL ESTADO DE CHILE'
            break;
        case '14':
            nombre = 'BANCO SCOTIABANK'
            break;

        case '16':
            nombre = 'BANCO DE CREDITO E INV'
            break;
        case '17':
            nombre = 'BANCO DO BRASIL S.A.'
            break;
        case '27':
            nombre = 'CORPBANCA'
            break;
        case '28':
            nombre = 'BANCO BICE'
            break;
        case '29':
            nombre = 'BANCO DE A.EDWARDS'
            break;
        case '31':
            nombre = 'HSBC BANK(CHILE)'
            break;
        case '33':
            nombre = 'CITIBANK N.A.'
            break;
        case '37':
            nombre = 'BANCO SANTANDER'
            break;
        case '39':
            nombre = 'ITAU (EX BANKBOSTON)'
            break;
        case '41':
            nombre = 'JP MORGAN CHASE BANK, N. A.'
            break;
        case '43':
            nombre = 'BANCO DE LA NACION ARGENTINA'
            break;
        case '45':
            nombre = 'THE BANK OF TOKIO'
            break;
        case '46':
            nombre = 'THE ROYAL BANK OF SCOTLAND (RBS)'
            break;
        case '49':
            nombre = 'BANCO SECURITY'
            break;
        case '51':
            nombre = 'BANCO FALABELLA'
            break;
        case '52':
            nombre = 'DEUTSCHE BANK (CHILE)'
            break;
        case '53':
            nombre = 'BANCO RIPLEY'
            break;
        case '54':
            nombre = 'BANCO HNS'
            break;
        case '55':
            nombre = 'BANCO CONSORCIO'
            break;
        case '56':
            nombre = 'BANCO PENTA'
            break;
        case '57':
            nombre = 'BANCO PARIS'
            break;
        case '59':
            nombre = 'BANCO BTG PACTUAL CHILE'
            break;
        case '60':
            nombre = 'CHINA CONSTRUCTION BANK'
            break;
        case '504':
            nombre = 'BANCO BBVA'
            break;
        case '507':
            nombre = 'BANCO DE DESARROLLO'
            break;
        default:
            break;
    }


    const Redireccionar = () => {

        history.push(parametros.rutaServidor + "informeonp")
    }

    if (DataOnp.IsOK == false) {
        //window.location.href ="/verifica2.aspx"
        setTimeout(() => {

            Redireccionar();
        }, 2000);

    }






    return (
        <>
            {/*  { !mostrar ? (*/}
            <div style={{ width: '100%' }}>
                <CssBaseline />
                {DataOnp.IsOK ? (
                    <Grid container spacing={3} component={Paper}>
                        <br /><br /><br />
                        <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
                            <div className={classes.print} style={{ float: 'left', marginTop: '5px' }}>
                                <Button variant="contained" color="primary" onClick={Redireccionar} >Nueva Consulta</Button>
                            </div>
                            <div className={classes.print} style={{ float: 'right', marginTop: '5px' }}>
                                Folio: {DataOnp.Folio}
                                <Tooltip title="imprimir">
                                    <Button style={{ marginTop: '3px' }} onClick={handleOpen} >
                                        <Icon color="primary">
                                            <PrintIcon />
                                        </Icon>
                                    </Button>
                                </Tooltip>
                            </div>
                            {!isMobile ?
                                <CardsHeader />
                                : <CardsHeaderMobile />}
                               {isMobile ? 
                               <div className={classes.print} style={{ float: 'center', alignContent: 'center', marginTop: '5px' }}>
                                    <Button variant="contained" color="primary" onClick={Redireccionar} >Nueva Consulta</Button> &nbsp;
                                Folio: {DataOnp.Folio}
                                <Tooltip title="imprimir">
                                    <Button style={{ marginTop: '3px' }} onClick={handleOpen} >
                                        <Icon color="primary">
                                            <PrintIcon />
                                        </Icon>
                                    </Button>
                                </Tooltip>
                            </div>
                            : '' }
                        </Grid>

                        <Grid container style={{ marginLeft: '0.5px' }} spacing={1} justify="space-around" xs={12} sm={12} md={12} lg={12} xl={12} >

                            <Grid item xs={6} sm={6} md={12} lg={2} xl={2} >

                                <Cards titulo={nombre ? <> <AccountBalanceIcon className={classes.sizeIcono} /> <br /> Banco </> : null} dato={nombre} />
                            </Grid>
                            <Grid item xs={6} sm={6} md={3} lg={2} xl={2} >

                                <Cards titulo={ctacte ? <><AccountBalanceWalletIcon className={classes.sizeIcono} /> <br /> Cta. Corriente </> : null} dato={ctacte} />
                            </Grid>
                            <Grid item hidden={serieRUT === ''} xs={12} sm={12} md={3} lg={2} xl={2} >
                                <Cards titulo={serieRUT ? <><FingerprintIcon className={classes.sizeIcono} /> <br /> Serie </> : null} dato={serieRUT} />
                            </Grid>
                            <Grid item xs={6} sm={6} md={3} lg={2} xl={2} >
                                <Cards titulo={number_format(monto) ? <><MonetizationOnIcon className={classes.sizeIcono} /> <br /> Monto </> : null} dato={number_format(monto)} />
                            </Grid>
                            <Grid item xs={6} sm={6} md={3} lg={2} xl={2} >
                                <Cards titulo={nrodoc ? <><FolderOpenIcon className={classes.sizeIcono} /> <br /> N° Documento  </> : null} dato={nrodoc} />
                            </Grid>
                        </Grid>

                        {/*TABLA RELACION / RUT*/}
                        <Grid item xs={12} sm={12} md={12} xl={12}>
                            <DataTableRelacionCtaRut />
                        </Grid>

                        {/* si le pongo container se pone como fila, se le coloca item se ve como columna*/}
                        <Grid container align="center" style={{ marginLeft: '1px' }} justify="space-around" xs={12} sm={12} md={12} lg={12} xl={12} spacing={2} >
                            {Verificacion != undefined || Verificacion != null ?
                                Verificacion.map((item) => (
                                    <Grid item hidden={item.Valor == ''} xs={6} sm={6} md={6} lg={2} xl={2}   >
                                        <Card style={{ marginTop: '15px' }} className={classes.table} component={Paper} elevation={4} > {/*hidden={item.Valor == ''} */}

                                            {/*Validacion de iconos segun el Concepto */}
                                            <div align="center" style={{ padding: '5px' }} ><Typography style={{ fontSize: '15px' }}    >
                                                {item.Concepto === 'Registra cuenta corriente Cerrada' ? <><AccountBalanceWalletIcon style={{ marginTop: '5px' }} className={classes.sizeIcono} /> <br /> {item.Concepto} </> : item.Concepto === 'Registra Consulta al Cheque' ? <><FindInPageIcon style={{ marginTop: '5px' }} className={classes.sizeIcono} /> <br /> {item.Concepto} </> : item.Concepto === 'Fecha ultima consulta al cheque' ? <> <DateRangeIcon style={{ marginTop: '5px' }} className={classes.sizeIcono} /> <br /> {item.Concepto} </> : item.Concepto === 'Motivo' ? <> <DescriptionIcon style={{ marginTop: '5px' }} className={classes.sizeIcono} /> <br /> {item.Concepto}<br /> </> : item.Concepto === 'Registra Orden de no Pago' ? <><AssignmentIcon style={{ marginTop: '5px' }} className={classes.sizeIcono} /> <br /> {item.Concepto}  </> : item.Concepto === 'Fecha ONP' && <> <DateRangeIcon style={{ marginTop: '5px' }} className={classes.sizeIcono} /> <br /> {item.Concepto} </>}
                                            </Typography>


                                                <div align="center" >
                                                    {/*Validacion de Colores segun el Valor */}
                                                    <Typography variant="h5" align="center" className={item.Valor === 'SI' ? classes.buttonNo : item.Valor === 'NO' ? classes.buttonSuccess : item.Valor === '' ? "no hay datos" : classes.button}  >{item.Valor === '' ? classes.button && "No especifica" : item.Valor}</Typography>
                                                </div>
                                            </div>
                                        </Card>
                                    </Grid>
                                ))
                                : history.push(parametros.rutaServidor + "informeonp")}
                        </Grid>
                        {/*TABLA INFORME COMERCIAL*/}
                        <Grid item xs={12} sm={12} md={12} xl={12}>
                            <DataTableInfoComercial />
                        </Grid>

                    </Grid>

                ) : (
                    <Box my={15} style={{ textAlign: 'center', alignContent: 'center', width: '100%' }}>

                    <Card>
                        <CardContent>

                            <h1>Sin resultado con los parametros ingresados</h1>
                            <Divider />
                            <p>Sera redireccionado en 2 segundos</p>
                            {/* <p>{this.state.message}</p> */}
                            <br />
                            <Button variant="contained" color="primary" onClick={Redireccionar}>Reintentar</Button>
                        </CardContent>

                    </Card>

                </Box>)
                }

            </div>
            {/* ) : (<InformeOnp/>) } PARTE DE LA ALTERNATIVA AL MODAL*/}

            <Modal
                aria-labelledby="transition-modal-title"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}>

                <Fade in={open}>
                    <div className={classes.papermodal}>
                        <h2 id="transition-modal-title">Informe Verificación ONP</h2>
                        <InformeOnp />
                    </div>
                </Fade>

            </Modal>

        </>
    );
}

export default InfoVerificacionTest;
